export const navigationBarId = 'navigation-bar'
export const blogTableOfContentsId = 'table-of-contents'
